export const damagePlotAreaConstants = {
    SET_DAMAGEPLOTAREAS: 'SET_DAMAGEPLOTAREAS',
    SAVE_DAMAGEPLOTAREA: 'SAVE_DAMAGEPLOTAREA',
    REMOVE_DAMAGEPLOTAREA: 'REMOVE_DAMAGEPLOTAREA',
};
